import SearchAPIActionCreators from 'search/actions/SearchAPIActionCreators';
import SearchResultsStore from 'search/stores/ResultsStore';
import SearchParamsStore from 'search/stores/ParamsStore';
import * as SearchParamsParser from 'utils/searchParamsParser';
import * as HistoryAPI from 'search/api/historyAPI';
import $ from 'jquery';
import { venuesPath } from 'routes';

export default {
  /**
   * Initialize search application stores so that everything will start working
   * once the first React view is created.
   */
  initialize() {
    HistoryAPI.replaceState({
      results: SearchResultsStore.get(),
      params: SearchParamsStore.get()
    });

    HistoryAPI.onPopState(newState => {
      SearchAPIActionCreators.setInitialResults(newState.results);
      SearchAPIActionCreators.setInitialParams(
        SearchParamsParser.parseSearchParams(newState.params)
      );
    });
  },

  /**
   * Initiate a search for venues from the venuu.fi internal API
   */
  searchVenues() {
    const params = SearchParamsParser.buildSearchParams(
      SearchParamsStore.get()
    );
    const timestamp = Date.now();

    SearchAPIActionCreators.fetchResultsStart(params, timestamp);

    $.ajax({
      url: venuesPath(),
      data: params,
      cache: false,
      dataType: 'json',
      success(data) {
        SearchAPIActionCreators.fetchResultsSuccess(data, timestamp);
        HistoryAPI.pushState({
          results: data,
          params: params
        });
      },
      error(_, textStatus, errorThrown) {
        SearchAPIActionCreators.fetchResultsFailure(
          `Searching for venues failed: ${textStatus}: ${errorThrown}`,
          timestamp
        );
      }
    });
  }
};
